
import { writable } from 'svelte/store';
import {push, pop, replace} from 'svelte-spa-router'
export const redirect_ = writable("");

redirect_.subscribe(val=>{
    if(val){
        console.log("Redirect",val)
        push(val)
    }
    
})
